import { render, staticRenderFns } from "./AttendanceForm.vue?vue&type=template&id=16cb62fa&"
import script from "./AttendanceForm.vue?vue&type=script&lang=js&"
export * from "./AttendanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports